class Gate {
	constructor (gateStartId) {
		this.$gateStart = $(`#${gateStartId}`);

		this.refresh();

		GateFormSubmittedEvent.addListener(
			data => this.onGateFormSubmitted(data)
		);

		ReturningUserNotYouClickedEvent.addListener(() => this.onNotYouClicked());
	}

	onGateFormSubmitted (data) {
		this.unlock(data);
		this.hideOverlay();
	}

	onNotYouClicked () {
		this.hideGateFormReturningUser();
		this.showGateFormRegister();
	}

	getGateOverlay () {
		return this.$gateStart.find('[data-component=gate-overlay]');
	}

	unlock (data) {
		new window.GateData().set(data);
	}

	isUnlocked () {
		return new window.GateData().isSet();
	}

	hideOverlay () {
		this.getGateOverlay().css('display', 'none');
		this.unblur();
	}

	getGateContentWrap () {
		return this.$gateStart.find('[data-component=gate-content-wrap]');
	}

	getGateFormRegister () {
		return this.$gateStart.find("[data-component=gate-form-register]")
	}

	showGateFormRegister () {
		this.getGateFormRegister().css("display", "");
	}

	getGateFormReturningUser () {
		return this.$gateStart.find("[data-component=gate-form-returning-user]");
	}

	showGateFormReturningUser () {
		this.getGateFormReturningUser().css("display", "");
	}

	hideGateFormReturningUser () {
		this.getGateFormReturningUser().css("display", "none");
	}

	unblur () {
		this.getGateContentWrap().css('filter', '');
	}

	refresh () {
		if (this.isUnlocked()) {
			this.showGateFormReturningUser();
		} else {
			this.showGateFormRegister();
		}
	}
}

$(document).ready(() => {
	$('[data-component=gate]').each((i, e) => {
		new Gate($(e).attr('id'));
	});
});
